export default "__VITE_ASSET__D_IIjwdE__"